// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.offer {
  position: relative;
  height: max-content;
  padding: 57rem 97rem 100rem;
}
@media (max-width: 660px) {
  .offer {
    padding: 23rem 20rem 100rem;
  }
}
@media (max-width: 660px) {
  .offer__wrapper {
    display: flex;
    flex-direction: column;
  }
}
.offer__title {
  color: var(--primary-color);
  font-size: 20rem;
  font-family: 'SB Sans Interface', sans-serif;
  line-height: 37rem;
  opacity: 0;
  transition: 0.6s opacity, 0.6s transform;
  transform: translateY(20rem);
}
@media (max-width: 660px) {
  .offer__title {
    margin-bottom: 28rem;
    font-size: 30rem;
    line-height: 38rem;
  }
}
.main[loaded] .offer__title {
  opacity: 1;
  transform: translateX(0);
}
.offer__desc {
  width: 100%;
  margin-top: 50rem;
  font-size: 30rem;
  line-height: 38rem;
  letter-spacing: -0.005em;
  opacity: 0;
  transition: 0.6s opacity, 0.6s transform;
  transition-delay: 0.6s;
  transform: translateX(-50rem);
}
@media (max-width: 660px) {
  .offer__desc {
    font-size: 18rem;
    line-height: 23rem;
  }
}
.main[loaded] .offer__desc {
  opacity: 1;
  transform: translateX(0);
}
.desc {
  margin-bottom: 20px;
  font-size: 15rem;
  line-height: 25px;
}
.md_list {
  margin: 0 0 0 19px;
  list-style-type: none;
  font-size: 15rem;
  counter-reset: num;
}
.md_list > li {
  position: relative;
  margin: 0;
  padding: 0 0 10px;
  list-style: disc;
  line-height: 2;
}
.md_list > li::marker {
  color: var(--primary-color);
  font-size: 18rem;
}
.markdown__link {
  color: var(--primary-color);
}
.markdown__link:hover {
  color: var(--blue);
}
.tg {
  margin-bottom: 10px;
  font-size: 15rem;
}
.tg tbody tr {
  padding: 2px;
}
.tg tbody tr th {
  vertical-align: middle;
  border-right: 1px solid var(--primary-color);
  font-weight: bold;
  line-height: 20px;
  text-align: center;
}
.tg tbody tr td {
  vertical-align: middle;
  padding: 20px;
  text-align: left;
}
.tg tbody tr td .desc {
  margin-bottom: 0;
}
.tg tbody tr:not(:first-child) {
  border-top: 1px solid var(--primary-color);
}
`, "",{"version":3,"sources":["webpack://./src/shared/ui/Markdown/Markdown.style.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,mBAAA;EACA,2BAAA;AACJ;AAEA;EACI;IACI,2BAAA;EAAN;AACF;AAGA;EACI;IACI,aAAA;IACA,sBAAA;EADN;AACF;AAIA;EACI,2BAAA;EACA,gBAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,wCAAA;EACA,4BAAA;AAFJ;AAKA;EACI;IACI,oBAAA;IACA,gBAAA;IACA,kBAAA;EAHN;AACF;AAMA;EACI,UAAA;EACA,wBAAA;AAJJ;AAOA;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EACA,wCAAA;EACA,sBAAA;EACA,6BAAA;AALJ;AAQA;EACI;IACI,gBAAA;IACA,kBAAA;EANN;AACF;AASA;EACI,UAAA;EACA,wBAAA;AAPJ;AAUA;EACI,mBAAA;EACA,gBAAA;EACA,iBAAA;AARJ;AAWA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAYA;EACI,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;AAaA;EACI,2BAAA;EACA,gBAAA;AAXJ;AAcA;EACI,2BAAA;AAZJ;AAcI;EACI,kBAAA;AAZR;AAgBA;EACI,mBAAA;EACA,gBAAA;AAdJ;AAYA;EAMY,YAAA;AAfZ;AASA;EASgB,sBAAA;EACA,4CAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;AAfhB;AAEA;EAiBgB,sBAAA;EACA,aAAA;EACA,gBAAA;AAhBhB;AAHA;EAsBoB,gBAAA;AAhBpB;AANA;EA4BY,0CAAA;AAnBZ","sourcesContent":[".offer {\n    position: relative;\n    height: max-content;\n    padding: 57rem 97rem 100rem;\n}\n  \n@media (max-width: 660px) {\n    .offer {\n        padding: 23rem 20rem 100rem;\n    }\n}\n  \n@media (max-width: 660px) {\n    .offer__wrapper {\n        display: flex;\n        flex-direction: column;\n    }\n}\n  \n.offer__title {\n    color: var(--primary-color);\n    font-size: 20rem;\n    font-family: 'SB Sans Interface', sans-serif;\n    line-height: 37rem;\n    opacity: 0;\n    transition: .6s opacity, .6s transform;\n    transform: translateY(20rem);\n}\n  \n@media (max-width: 660px) {\n    .offer__title {\n        margin-bottom: 28rem;\n        font-size: 30rem;\n        line-height: 38rem;\n    }\n}\n  \n.main[loaded] .offer__title {\n    opacity: 1;\n    transform: translateX(0);\n}\n  \n.offer__desc {\n    width: 100%;\n    margin-top: 50rem;\n    font-size: 30rem;\n    line-height: 38rem;\n    letter-spacing: -.005em;\n    opacity: 0;\n    transition: .6s opacity, .6s transform;\n    transition-delay: .6s;\n    transform: translateX(-50rem);\n}\n  \n@media (max-width: 660px) {\n    .offer__desc {\n        font-size: 18rem;\n        line-height: 23rem;\n    }\n}\n  \n.main[loaded] .offer__desc {\n    opacity: 1;\n    transform: translateX(0);\n}\n  \n.desc {\n    margin-bottom: 20px;\n    font-size: 15rem;\n    line-height: 25px;\n}\n  \n.md_list {\n    margin: 0 0 0 19px;\n    list-style-type: none;\n    font-size: 15rem;\n    counter-reset: num;\n}\n  \n.md_list > li {\n    position: relative;\n    margin: 0;\n    padding: 0 0 10px;\n    list-style: disc;\n    line-height: 2;\n}\n  \n.md_list > li::marker {  \n    color: var(--primary-color);\n    font-size: 18rem;\n}\n\n.markdown__link {\n    color: var(--primary-color);\n    \n    &:hover {\n        color: var(--blue)\n    }\n}\n  \n.tg {\n    margin-bottom: 10px;\n    font-size: 15rem;\n\n    tbody {\n        tr {\n            padding: 2px;\n  \n            th {\n                vertical-align: middle;\n                border-right: 1px solid var(--primary-color);\n                font-weight: bold;\n                line-height: 20px;\n                text-align: center;\n            }\n  \n            td {\n                vertical-align: middle;\n                padding: 20px;\n                text-align: left;\n  \n                .desc {\n                    margin-bottom: 0;\n                }\n            }\n        }\n  \n        tr:not(:first-child) {\n            border-top: 1px solid var(--primary-color);\n        }\n    }\n}\n  "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
